import React from 'react';
import {
    Alert,
    Button,
    Div,
    RichCell,
    SplitCol,
    SplitLayout,
} from '@vkontakte/vkui';
import {
    AdaptivityContext,
    getStaffPositions,
    SELLER_QUALIFICATIONS,
} from "../../assets/constants";
import {
    Icon20AddCircleFillGreen,
    Icon20DeleteOutline,
    Icon20EditCircleFillBlue,
} from "@vkontakte/icons";
import moment from "moment";
import BaseList from "../../components/BaseList";
import SalePointSellersApi from "../../api/references/salePointSellers";
import withOffline from "../../components/withOffline";

class StaffList extends BaseList {

    getItems = (mainSearch = '', append = false, page = 1) => {
        clearInterval(this.searchInterval);
        this.setState({loading: true})
        append = append == undefined ? false : append
        if (page == undefined) {
            page = this.state.page;
        }
        if (mainSearch == '') {
            mainSearch = this.state.mainSearch
        }

        SalePointSellersApi.getList({
            search: mainSearch,
            page,
            epp: AdaptivityContext.isMobile ? 10 : 20
        }).then(response => {
            this.setState({loading: false})
            const results = (response.data && response.data.results) ? response.data.results : []
            let old = this.state.items;
            if (!append) {
                old = results
            } else {
                results.map((el) => {
                    old.push(el)
                })
            }

            this.setState({
                items: old,
                cnt_items: response.data.iTotalRecords || 0,
                totalPages: response.data.iTotalPages || 1
            })

            if (response.data.iTotalPages * 1 > 0) {
                setTimeout(() => {
                    this.checkScroll()
                }, 500)
            }
        }).catch(() => {
            this.setState({loading: false})
        })
    }

    getObjectLink = (item) => {
        if (!item || item.id == null || item.id <= 0) {
            return null;
        }
        return {type: 'staff', id: item.id};
    }

    createItem = () => {
        window.postMessage({
            type: 'setCurrentStaff',
            value: {
                id: -1,
                last_name: '',
                first_name: '',
                middle_name: '',
                birth_date: null,
                phone: '',
                position_id: 0,
                sale_point_id: 0,
                sale_point: null,
                is_owner: 0,
                is_lpr: 0,
                qualification: 0,
                comment: '',
            }
        })
    }

    getItem = (item) => {
        this.setLastOpenedItem(item.id);
        SalePointSellersApi.getOne(item.id).then(response => {
            const {data} = response
            if (data && data.id) {
                window.postMessage({type: 'setCurrentStaff', value: data})
            }
        })
    }

    deleteItem = (item, index) => {
        const fio = [item.last_name, item.first_name, item.middle_name].filter(Boolean).join(' ')
        const alert = <Alert
            onClose={() => this.setState({currentPopout: null})}
            actionsAlign="left"
            actionsLayout="horizontal"
            actions={[
                {
                    title: 'Да',
                    action: () => {
                        SalePointSellersApi.setDeleted(item.id).then(response => {
                            const {data} = response
                            if (data.success) {
                                const {items} = this.state
                                items.splice(index, 1)
                                this.setState({items, currentPopout: null, cnt_items: Math.max(0, this.state.cnt_items - 1)})
                            }
                        })
                    },
                },
                {
                    title: 'Нет',
                    action: () => {
                        this.setState({currentPopout: null})
                    },
                },
            ]}
            header="Удаление сотрудника"
            text={`Удалить сотрудника ${fio}?`}
        />
        this.setState({currentPopout: alert})
    }

    renderToolbar = () => {
        return <div
            className={AdaptivityContext.isMobile || true ? 'mobile-table-storage-header' : 'desktop-table-storage-header'}>
            <SplitLayout>
                <SplitCol style={{justifyContent: "flex-start"}}>
                    <Div>
                        <Button mode="outline" disabled={this.props.isOffline || this.state.isOffline}
                                onClick={() => this.createItem()}><Icon20AddCircleFillGreen/></Button>
                    </Div>
                </SplitCol>
                <SplitCol>
                    <Div>
                        <span className="all-docs" id="cnt_items">Всего элементов: {this.state.cnt_items}</span>
                    </Div>
                </SplitCol>
            </SplitLayout>
        </div>
    }

    salePointLine = (item) => {
        const sp = item.sale_point || {}
        const parts = [
            sp.klient && sp.klient.title,
            sp.title || item.sale_point_title,
            sp.full_address,
        ].filter(Boolean)
        return parts.length ? parts.join(' · ') : 'ТТ не указана'
    }

    renderRow = (item, index) => {
        const fio = [item.last_name, item.first_name, item.middle_name].filter(Boolean).join(' ')
        const positions = getStaffPositions()
        const positionTitle = item.position_title || positions[item.position_id] || ''
        const qualTitle = item.qualification_title || SELLER_QUALIFICATIONS[item.qualification] || ''
        const flags = [
            item.is_owner ? 'Собственник' : null,
            item.is_lpr ? 'ЛПР' : null,
            qualTitle || null,
        ].filter(Boolean).join(' · ')
        const moderated = item.moderated_at
            ? moment.unix(item.moderated_at).format('DD.MM.YYYY HH:mm')
            : ''

        return <RichCell multiline
                         style={this.getRowStyle(item)}
                         subhead={this.salePointLine(item)}
                         caption={[item.phone, positionTitle].filter(Boolean).join(' · ')}
                         bottom={
                             <div>
                                 {flags ? <div>{flags}</div> : null}
                                 {moderated ? <div>Модерация: {moderated}{item.moderated_by_login ? ` · ${item.moderated_by_login}` : ''}</div> : null}
                             </div>
                         }
                         afterCaption={<div style={{display: "flex", flexDirection: "column"}}>
                             <Button mode="outline" size="m"
                                     onClick={() => this.getItem(item)}><Icon20EditCircleFillBlue/></Button>
                             <Button mode="outline" size="m"
                                     onClick={() => this.deleteItem(item, index)}><Icon20DeleteOutline/></Button>
                         </div>}
        >
            {fio || 'Без ФИО'}
        </RichCell>
    }
}

export default withOffline(StaffList)
